import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { QueuesPage } from '../screens/admin/QueuesPage';

const places = [
  'arriving_api',
  'preparing',
  'reading',
  'splitting',
  'understanding',
  'checking',
  'arriving_engine',
  'engine',
  'review',
  'export',
] as const;

const searchSchema = z.object({
  /** Drill the cluster picture to one tenant. */
  tenant: z.string().optional(),
  /** The stage whose drawer is open. */
  place: z.enum(places).optional().catch(undefined),
  /** The incident open in it ("parked:render_failed", "slow:reading"). */
  incident: z.string().max(120).optional(),
});

export const Route = createFileRoute('/admin/queues')({
  validateSearch: searchSchema,
  component: QueuesPage,
});
